'use client';
var styles = {"article":"Divider-module_article__rEFKi"};

export { styles as default };
